import React, { createContext, useContext, useState } from "react";
import { Modal } from "taltech-styleguide";
import { ModalProps } from "./modal.types";
import { PropsOrComponent } from "./ModalTrigger";
import { propsOrComponent } from "../_utils/props-or-component";
import { createDynamicComponent } from "../_utils";
import { IRootieComponent } from "../_types";

export type ModelContextProps = {
  showModal: (component: PropsOrComponent<ModalProps>) => void;
  hideModal: () => void;
};

const ModalContext = createContext<ModelContextProps>({
  showModal: (component) => {
    return;
  },
  hideModal: () => {},
});

export function useModal() {
  return useContext(ModalContext);
}

export const ModalProvider = ({ children }: any) => {
  const [isVisible, setIsVisible] = useState(false);
  const [modalSize, setModalSize] = useState<"sm" | "lg" | "xl">("sm");
  const [component, setComponent]: [IRootieComponent<ModalProps> | null, any] =
    useState(null);

  const showModal = (elem: PropsOrComponent<ModalProps>) => {
    const modalProps: any = propsOrComponent(
      { ...elem, onClose: hideModal, show: true },
      Modal as any
    );

    if (elem.size) setModalSize(elem.size);
    else setModalSize("lg");

    const dynamicComponent = createDynamicComponent(modalProps);
    setComponent(dynamicComponent);
    setIsVisible(true);
  };

  const hideModal = () => {
    setIsVisible(false);
    setComponent(null);
    setModalSize("lg");
  };

  return (
    <ModalContext.Provider value={{ showModal, hideModal }}>
      {children}
      <Modal show={isVisible} size={modalSize}>{component}</Modal>
    </ModalContext.Provider>
  );
};
